"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appRequest = appRequest;
exports.createPath = createPath;
exports.getErrorMessage = getErrorMessage;
exports.isInvalidSession = isInvalidSession;
exports.isUnprivilegedUser = isUnprivilegedUser;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function isInvalidSession(error) {
  var _error$response;
  return (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401;
}
function isUnprivilegedUser(error) {
  var _error$response2;
  return (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 403;
}
function appRequest(config) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var timeout = 60000;
  if (config.timeout !== undefined) {
    timeout = config.timeout;
  }
  var defaults = {
    method: method,
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      'Content-Type': 'application/json'
    }),
    data: body,
    timeout: timeout
  };
  var finalConfig = (0, _lodash.merge)({}, defaults, config);
  // make request
  return _axios.default.request(finalConfig);
}
function getErrorMessage(err) {
  var _err$response, _err$response$data;
  // if api returns an error message, use it. Otherwise, use error message from axios itself
  return err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.message ? err.response.data.message : err.message;
}
function createPath(operation, params) {
  var path = operation;
  if (params && params.length > 0) {
    path = operation.concat("?".concat(params.join('&')));
  }
  return path;
}